<template>
  <ul class="consult-channel-sort-bar">
    <div
      v-if="activityData"
      :class="[
        'sort-item',
        'activity-tag',
        { active: +value.anniversary && selected }
      ]"
      @click="handleClickActiveTag"
    >
      <img :src="+value.anniversary ? activityData.active : activityData.img" />
    </div>
    <div
      :class="[
        'sort-item',
        { active: value[item.type] == item.value && selected }
      ]"
      v-for="(item, index) in list"
      :key="index"
      @click="change(item)"
    >
      {{ item.name }}
    </div>
    <div v-if="mask" class="mask"></div>
  </ul>
</template>

<script>
const activityDatas = [
  {
    img: require('app/web/images/consult/indexV5/db11Tag.png'),
    active: require('app/web/images/consult/indexV5/db11Tag-active.png')
  },
  {
    img: require('app/web/images/consult/indexV5/anniversaryTag.png'),
    active: require('app/web/images/consult/indexV5/anniversaryTag-active.png')
  }
]
export default {
  props: {
    value: { type: Object },
    list: {
      type: Array
    },
    mask: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: true
    },
    showActivityTag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activityType: 2
    }
  },
  computed: {
    activityData() {
      return (this.showActivityTag && activityDatas[this.activityType]) || null
    }
  },
  mounted() {
    // 活动标签 2023-11-01～2023-12-31
    const { activityType } = this.$route.query
    if (activityType) return (this.activityType = activityType - 1)
    const { recentTeachers } = this.$store.state.consultListCommon || {}
    const date = recentTeachers?.current_time?.split(' ')[0].replace(/-/gi, '/')
    const curTime = date ? new Date(date).getTime() : Date.now()
    this.activityType =
      curTime > new Date('2023/12/31 23:59:59').getTime() ||
      curTime < new Date('2023/10/31 00:00:00').getTime()
        ? 2
        : curTime <= new Date('2023/11/15 23:59:59').getTime()
        ? 0
        : 1
  },
  methods: {
    handleClickActiveTag() {
      this.$emit('change', { child_tag: '', anniversary: 1 })
    },
    change(item) {
      const obj = {}
      for (let i = 0; i < this.list.length; i++) {
        const v = this.list[i]
        if (this.value[v.type] === v.value) {
          obj[v.type] = undefined
        }
      }

      item.stat && this.eventStat(item.stat)

      this.$emit('change', {
        ...obj,
        [item.type]: item.value,
        anniversary: ''
      })

      this.$emit('sortBarClick', {
        item
      })
    }
  }
}
</script>

<style lang="scss">
.consult-channel-sort-bar {
  height: 80px;
  // @include flex(row, flex-start, center);
  padding: 0 40px 0;
  // margin-bottom: 30px;
  // position: absolute;
  // top: 80px;
  overflow-x: auto;
  // width: 750px;
  // left: 50%;
  // margin-left: -375px;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  box-sizing: border-box;

  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .sort-item {
    margin-top: 3px;
    height: 44px;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 9px 18px;
    font-size: 26px;
    line-height: 26px;
    display: inline-block;
    vertical-align: top;
    color: #6c798c;
    text-align: center;
    &:not(:last-child) {
      margin-right: 20px;
    }
    &.active {
      background-color: #fff;
      color: #6982fa;
      font-weight: 700;
    }
    &.activity-tag {
      position: relative;
      img {
        position: relative;
        width: 72px;
        height: 30px;
      }
    }
  }
  .mask {
    position: absolute;
    display: inline-block;
    content: '';
    width: 90px;
    height: 50px;
    background: #000;
    right: 40px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(243, 244, 245, 1)
    );
    border-radius: 0 8px 8px 0;
    pointer-events: none;
  }
}
</style>
